import { useSignal } from '@preact/signals-react'
import { useSignals } from '@preact/signals-react/runtime'
import Markdown from 'markdown-to-jsx'
import { memo } from 'react'
import * as $ from '../../signal/searchbox'
import type { SummaryChatMessage } from '../../types'
import { CodeHighlighter } from '../CodeHighlighter/CodeHighlighter'
import styles from './Summary.module.css'

export const SummaryMarkdown = memo(({ item }: { item: SummaryChatMessage }) => {
  useSignals()
  const colorScheme = useSignal($.colorScheme).value

  return (
    <>
      <Markdown
        key={item.content}
        options={{
          overrides: {
            a: {
              component: ({ children, href }) => (
                <a href={href} target="_blank" rel="noreferrer">
                  {children}
                </a>
              )
            },
            code: {
              component: ({ children, className }) => {
                const language = className?.replace('lang-', '')

                if (!language) return <code className={styles.inline__code}>{children}</code>
                return (
                  <CodeHighlighter language={language} colorSchemeName={colorScheme.value}>
                    {children as string}
                  </CodeHighlighter>
                )
              }
            },
            b: {
              component: ({ children }) => <b>{children}</b>
            },
            p: {
              component: ({ children }) => <p style={{ marginTop: 8, marginBottom: 8 }}>{children}</p>
            }
          }
        }}
      >
        {item.content}
      </Markdown>
    </>
  )
})
